import './index.css'
import './i18n'
import './lib/utils/strMethods'

import React from 'react'
import ReactDOM from 'react-dom'
import ruLocale from 'date-fns/locale/ru'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { SnackbarProvider } from 'notistack'
import { StylesProvider } from '@material-ui/core/styles'
import { ThemeProvider } from '@material-ui/core'
import { AuthStoreProvider } from 'context/AuthStore'
import { asterTheme } from 'asterX-UI'
import { ModalbarProvider } from 'lib/modules/Modalbar'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'

import App from './App'

ReactDOM.render(
  <ThemeProvider theme={asterTheme}>
    <StylesProvider>
      <BrowserRouter>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ruLocale}>
          <SnackbarProvider
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
            autoHideDuration={3000}
          >
            <ModalbarProvider>
              <Switch>
                <Route
                  path="/"
                  render={props => (
                    <AuthStoreProvider {...props}>
                      <App {...props} />
                    </AuthStoreProvider>
                  )}
                />
              </Switch>
            </ModalbarProvider>
          </SnackbarProvider>
        </MuiPickersUtilsProvider>
      </BrowserRouter>
    </StylesProvider>
  </ThemeProvider>,
  document.getElementById('root')
)
